import React from 'react';
import { C, Sum, Masks } from 'shared/helpers';
import PropTypes from 'prop-types';

import Styles from './Subtable.module.scss';

export default function Subtable({ produtos }) {
  const { Subtable, Column, Pillar, First, Second, Third } = Styles;

  const { number } = Masks;

  let divCount = 0;
  const k = () => `subtable${++divCount}`;

  const Prods = {
    SQMV: {
      NO3: Sum(
        produtos
          .filter(x => x.fase_id === 2)
          .map(x => (Number(x.NO3 || 0) / 100) * x.quantidade),
      ),
      NH2: Sum(
        produtos
          .filter(x => x.fase_id === 2)
          .map(x => (Number(x.NH2 || 0) / 100) * x.quantidade),
      ),
      NH4: Sum(
        produtos
          .filter(x => x.fase_id === 2)
          .map(x => (Number(x.NH4 || 0) / 100) * x.quantidade),
      ),
      N: Sum(
        produtos
          .filter(x => x.fase_id === 2)
          .map(x => (Number(x.N || 0) / 100) * x.quantidade),
      ),
    },
    Convencional: {
      NO3: Sum(
        produtos
          .filter(x => x.fase_id === 3)
          .map(x => (Number(x.NO3 || 0) / 100) * x.quantidade),
      ),
      NH2: Sum(
        produtos
          .filter(x => x.fase_id === 3)
          .map(x => (Number(x.NH2 || 0) / 100) * x.quantidade),
      ),
      NH4: Sum(
        produtos
          .filter(x => x.fase_id === 3)
          .map(x => (Number(x.NH4 || 0) / 100) * x.quantidade),
      ),
      N: Sum(
        produtos
          .filter(x => x.fase_id === 3)
          .map(x => (Number(x.N || 0) / 100) * x.quantidade),
      ),
    },
  };

  return (
    <div className={Subtable}>
      <header>
        <div style={{ backgroundColor: 'white' }} />
        <div>SQM VITAS</div>
        <div>Convencional</div>
        <div>Diferença</div>
      </header>
      <main>
        <div className={Pillar}>
          <div>Nítrico NO3</div>
          <div>Amoniacal NH4</div>
          <div>Amídico NH2</div>
          <div>Total</div>
        </div>
        <div className={C(Column, First)}>
          {['NO3', 'NH4', 'NH2'].map(key => (
            <div key={k()}>
              {number((Prods.SQMV[key] / Prods.SQMV.N) * 100 || 0, {
                suffix: '%',
                ed: 2,
              })}
            </div>
          ))}
          <div>
            {number(
              Object.entries(Prods.SQMV)
                .filter(e => e[0] !== 'N')
                .map(v => (v[1] / Prods.SQMV.N) * 100) || 0,
              { suffix: '%', ed: 2 },
            )}
          </div>
        </div>
        <div className={C(Column, Second)}>
          {['NO3', 'NH4', 'NH2'].map(key => (
            <div key={k()}>
              {number(
                (Prods.Convencional[key] / Prods.Convencional.N) * 100 || 0,
                { suffix: '%', ed: 2 },
              )}
            </div>
          ))}
          <div>
            {number(
              Object.entries(Prods.Convencional)
                .filter(e => e[0] !== 'N')
                .map(v => (v[1] / Prods.Convencional.N) * 100),
              { suffix: '%', ed: 2 },
            )}
          </div>
        </div>
        <div className={C(Column, Third)}>
          {['NO3', 'NH4', 'NH2'].map(key => (
            <div key={k()}>
              {number(
                ((Prods.SQMV[key] / Prods.SQMV.N || 0) /
                  (Prods.Convencional[key] / Prods.Convencional.N) -
                  1) *
                  100 || 0,
                { suffix: '%', ed: 2 },
              )}
            </div>
          ))}
          <div>---</div>
        </div>
      </main>
    </div>
  );
}

Subtable.propTypes = {
  produtos: PropTypes.array.isRequired,
};
